import React, { useState, useEffect, useRef } from "react";
import CustomLoader from "../../components/CustomeLoader";
import makeicon from "../../ulits/images/make_icon.svg";
import usicon from "../../ulits/images/us_icon.svg";
import milgeicon from "../../ulits/images/milge_icon.svg";
import timeicon from "../../ulits/images/time_icon.svg";
import entercaricon from "../../ulits/images/enter_car_icon.svg";
import clearedicon from "../../ulits/images/cleared_icon.svg";
import cameraicon from "../../ulits/images/camera_icon.svg";
import carsicon from "../../ulits/images/cars_icon.svg";
import staricon from "../../ulits/images/star-img.svg";
import googlepay from "../../ulits/images/google-pay.svg";
import Accordion from "react-bootstrap/Accordion";
import { configs } from "../../config";
import { Link, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { homeAction } from "../../_action/homeAction";
import { status } from "../../_constants/commanLHd";
import gmailicon from "../../ulits/images/gmail_icon.svg";
import callicon from "../../ulits/images/tell_icon.svg";
import usericon from "../../ulits/images/user_icon.svg";
import { alert } from "../../_utilities/alert";
import { Helmet } from "react-helmet-async";
import { configAction } from "../../_action/configAction";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css/free-mode";
import "swiper/css/autoplay";
import whatsApp from "../../ulits/images/WatSapp-icon.svg";

function Home() {
  const formSectionRef = useRef(null);
  const [loader, setLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [brands, setBrands] = useState([]);
  const [showSecondForm, setShowSecondForm] = useState(false);
  const [isValidate, setIsValidate] = useState(false);
  const [isValidateContact, setIsValidateContact] = useState(false);
  const carRegistrationData = useSelector((state) => state.home);
  const [seo, setSeo] = useState({});
  const seoData = useSelector((state) => state.config);
  const [isNameFocused, setIsNameFocused] = useState(false);
  const [isEmailFocused, setIsEmailFocused] = useState(false);
  const [isPhoneFocused, setIsPhoneFocused] = useState(false);
  const [isMakeFocused, setIsMakeFocused] = useState(false);
  const [isModelocused, setIsModelFocused] = useState(false);
  const [isCaroFcused, setIsCarFocused] = useState(false);
  const [isMileageoFcused, setIsMileageFocused] = useState(false);
  const faqData = useSelector((state) => state.home);
  const [credentials, setCredentials] = useState({
    make: "",
    model: "",
    carRegistration: "",
    mileage: "",
  });

  useEffect(() => {
    dispatch(homeAction.getBrandsByTenantId());
  }, [dispatch]);


  const homeData = useSelector((state) => state.home);

  const [credentialsForContact, setCredentialsForContact] = useState({
    name: "",
    email: "",
    phone: "",
    carId: "",
  });

  const config = localStorage.getItem("config")
    ? JSON.parse(localStorage.getItem("config"))
    : null;

  const faqList =
    faqData?.faq_data?.filter(faq => faq.status === true) || [];


  useEffect(() => {
    if (seoData && seoData.seo_status === status.SUCCESS) {
      setSeo(seoData.seo_data);
    }
  }, []);

  useEffect(() => {
    dispatch(homeAction.getFaq());
    dispatch(configAction.getSeoData());
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    if (carRegistrationData?.carRegister_status == status.SUCCESS) {
      const data = carRegistrationData?.carRegister_data;
      setCredentialsForContact({ carId: data._id });
      setCredentials({
        make: "",
        model: "",
        carRegistration: "",
        mileage: "",
      });
    } else {
      setIsValidate(false);
      setCredentials({
        make: "",
        model: "",
        carRegistration: "",
        mileage: "",
      });
    }
  }, [carRegistrationData?.carRegister_data]);

  useEffect(() => {
    if (carRegistrationData?.contact_status == status.SUCCESS) {
      setIsValidateContact(false);
      setCredentialsForContact({
        name: "",
        email: "",
        phone: "",
      });
    } else {
      setCredentialsForContact({
        name: "",
        email: "",
        phone: "",
      });
    }
  }, [carRegistrationData?.contact_data]);

  const validateCredentialsForRegistration = (isValidate) => {
    const validObj = {
      message: "",
      isValid: true,
    };

    let isValid = true;
    const retData = {
      make: validObj,
      model: validObj,
      carRegistration: validObj,
      mileage: validObj,
      isValid,
    };

    if (isValidate) {
      const { make, model, carRegistration, mileage } = credentials;

      if (!make) {
        retData.make = {
          message: "Make is required",
          isValid: false,
        };
        isValid = false;
      } else if (make && make.length <= 2) {
        retData.make = {
          message: "Make must be at least 3 characters",
          isValid: false,
        };
        isValid = false;
      }

      if (!model) {
        retData.model = {
          message: "Model is required",
          isValid: false,
        };
        isValid = false;
      } else if (model && model.length <= 2) {
        retData.model = {
          message: "Model must be at least 3 characters",
          isValid: false,
        };
        isValid = false;
      }

      if (!carRegistration) {
        retData.carRegistration = {
          message: "carRegistration is required",
          isValid: false,
        };
        isValid = false;
      } else if (carRegistration && carRegistration.length <= 2) {
        retData.carRegistration = {
          message: "Car Registration must be at least 3 characters",
          isValid: false,
        };
        isValid = false;
      }

      if (!mileage) {
        retData.mileage = {
          message: "Mileage is required",
          isValid: false,
        };
        isValid = false;
      }

      retData.isValid = isValid;
      return retData;
    }
  };

  const validateCredentialsForContact = (isValidateContact) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const PhoneRegex = /^\d{10,12}$/;
    const validObj = {
      message: "",
      isValid: true,
    };

    let isValid = true;
    const retData = {
      name: validObj,
      email: validObj,
      phone: validObj,
      isValid,
    };

    if (isValidateContact) {
      const { name, email, phone } = credentialsForContact;

      if (!name) {
        retData.name = {
          message: "Name is required",
          isValid: false,
        };
        isValid = false;
      } else if (name && name.length <= 2) {
        retData.name = {
          message: "Name must be at least 3 characters",
          isValid: false,
        };
        isValid = false;
      }

      if (!email) {
        retData.email = {
          message: "Email is required",
          isValid: false,
        };
        isValid = false;
      } else if (!emailRegex.test(email)) {
        retData.email = {
          message: "Enter a valid email address",
          isValid: false,
        };
        isValid = false;
      }

      if (!phone) {
        retData.phone = {
          message: "Phone Number is required",
          isValid: false,
        };
        isValid = false;
      } else if (!PhoneRegex.test(phone)) {
        retData.phone = {
          message: "Phone number must be 10 to 12 digits",
          isValid: false,
        };
        isValid = false;
      }

      retData.isValid = isValid;
      return retData;
    }
  };

  const handleCarRegistration = (e) => {
    e.preventDefault();
    setIsValidate(true);
    const error = validateCredentialsForRegistration(true);
    if (error.isValid) {
      dispatch(homeAction.carRegister(credentials));
      setShowSecondForm(true);
    }
  };

  const handleContactsubmission = (e) => {
    e.preventDefault();
    setIsValidateContact(true);

    const error = validateCredentialsForContact(true);
    if (error.isValid) {
      dispatch(homeAction.contact(credentialsForContact));
      setShowSecondForm(false);
    }
  };

  const registrationError = validateCredentialsForRegistration(isValidate);
  const contactError = validateCredentialsForContact(isValidateContact);

  const isDesktop = window.innerWidth > 768;
  const gap = isDesktop ? 0.0285 * window.innerWidth : 15;

  useEffect(() => {
    if (homeData && homeData.brands_status === status.SUCCESS) {
      setBrands(homeData.brands_data);
    }
  }, [homeData]);

  const scrollToForm = () => {
    if (formSectionRef.current) {
      formSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    async function fetchReviews() {
      try {
        const response = await fetch(` ${configs.localApiUrl}/reviews?placeId=${config?.Google_PlaceId}`);
        const data = await response.json();
        console.log("Google API Response:", data);
        setReviews(data.reviews || []);
      } catch (err) {
        console.error("Error fetching Google reviews:", err);
      }
    }

    if (config?.Google_PlaceId) {
      fetchReviews();
    }
  }, []);

  return (
    <>
      <Helmet>
        <meta name="description" content={seo && seo.Meta_Description} />
        <meta name="keywords" content={seo && seo.Meta_Keywords} />
      </Helmet>
      {loader ? (
        <CustomLoader />
      ) : (
        <div className="main-wrapper">
          <div className="container">
            <div className="e-con-image">
              <img
                src={`${configs.localApiUrl}${config?.Banner_Image}`}
                alt=""
                className="img-fluid"
              />
              <div className="WatSapp-icon">
                <div className="whatsapp-icon">
                  <Link
                  to={`https://wa.me/${config?.Contact_Number?.replace(/\D/g, '')}`}
                    target="_blank"
                  >
                    <img src={whatsApp} alt="whatsapp" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div
            id="sell-your-car-form"
            className="sell-your-car"
            ref={formSectionRef}
          >
            <div className="container">
              <div className="sell-your-car-inner" id="sell-your-car-section">
                <div className="sell-your-car-left">
                  {!showSecondForm ? (
                    <>
                      <h1>SELL YOUR CAR THE BIG WAY</h1>
                      <p>
                        Get guaranteed valuation with free collection & no fees!
                      </p>
                      <div className="form-container">
                        <div className="form-group">
                          <div className="input-box">
                            <span>
                              <img src={makeicon} alt="" />
                            </span>
                            <input
                              type="text"
                              id="make"
                              name="make"
                              placeholder={!isMakeFocused ? "MAKE" : ""}
                              onFocus={() => setIsMakeFocused(true)}
                              onBlur={() => setIsMakeFocused(false)}
                              class="form-control"
                              autoComplete="off"
                              value={credentials.make}
                              onChange={(e) => {
                                setCredentials({
                                  ...credentials,
                                  make: e.target.value,
                                });
                              }}
                            />
                          </div>
                          {registrationError &&
                            registrationError.make.message !== "" && (
                              <div
                                className="error-message"
                                style={{ color: "red" }}
                              >
                                {registrationError.make.message}
                              </div>
                            )}
                        </div>
                        <div className="form-group">
                          <div className="input-box">
                            <span>
                              <img src={makeicon} alt="" />
                            </span>
                            <input
                              type="text"
                              id="model
                            "
                              name="model"
                              placeholder={!isModelocused ? "MODAL" : ""}
                              onFocus={() => setIsModelFocused(true)}
                              onBlur={() => setIsModelFocused(false)}
                              class="form-control"
                              autoComplete="off"
                              value={credentials.model}
                              onChange={(e) => {
                                setCredentials({
                                  ...credentials,
                                  model: e.target.value,
                                });
                              }}
                            />
                          </div>
                          {registrationError &&
                            registrationError.model.message !== "" && (
                              <div
                                className="error-message"
                                style={{ color: "red" }}
                              >
                                {registrationError.model.message}
                              </div>
                            )}
                        </div>
                        <div className="form-group">
                          <div className="input-box">
                            <span>
                              <img src={makeicon} alt="" />
                            </span>
                            <input
                              type="text"
                              id="carRegistration"
                              name="carRegistration"
                              placeholder={
                                !isCaroFcused ? "YOUR CAR REGISTRATION" : ""
                              }
                              onFocus={() => setIsCarFocused(true)}
                              onBlur={() => setIsCarFocused(false)}
                              class="form-control"
                              autoComplete="off"
                              value={credentials.carRegistration}
                              onChange={(e) => {
                                setCredentials({
                                  ...credentials,
                                  carRegistration: e.target.value,
                                });
                              }}
                            />
                          </div>
                          {registrationError &&
                            registrationError.carRegistration.message !==
                            "" && (
                              <div
                                className="error-message"
                                style={{ color: "red" }}
                              >
                                {registrationError.carRegistration.message}
                              </div>
                            )}
                        </div>
                        <div className="form-group">
                          <div className="input-box">
                            <span>
                              <img src={milgeicon} alt="" />
                            </span>
                            <input
                              type="text"
                              id="mileage"
                              name="mileage"
                              placeholder={!isMileageoFcused ? "MILEAGE" : ""}
                              onFocus={() => setIsMileageFocused(true)}
                              onBlur={() => setIsMileageFocused(false)}
                              class="form-control"
                              autoComplete="off"
                              value={credentials.mileage}
                              onChange={(e) => {
                                setCredentials({
                                  ...credentials,
                                  mileage: e.target.value,
                                });
                              }}
                            />
                          </div>
                          {registrationError &&
                            registrationError.mileage.message !== "" && (
                              <div
                                className="error-message"
                                style={{ color: "red" }}
                              >
                                {registrationError.mileage.message}
                              </div>
                            )}
                        </div>
                        <button
                          className="cta-button"
                          onClick={(e) => handleCarRegistration(e)}
                        >
                          START MY VALUATION
                          <div className="arrow-icon"></div>
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <h1>SELL YOUR CAR THE BIG WAY</h1>
                      <p>
                        Get guaranteed valuation with free collection & no fees!
                      </p>
                      <div className="form-container second-form">
                        <div className="form-group">
                          <div className="input-box">
                            <span>
                              <img src={usericon} alt="" />
                            </span>
                            <input
                              type="text"
                              id="name"
                              name="name"
                              placeholder={!isNameFocused ? "Name" : ""}
                              onFocus={() => setIsNameFocused(true)}
                              onBlur={() => setIsNameFocused(false)}
                              class="form-control"
                              autoComplete="off"
                              value={credentialsForContact.name}
                              onChange={(e) => {
                                setCredentialsForContact({
                                  ...credentialsForContact,
                                  name: e.target.value,
                                });
                              }}
                            />
                          </div>
                          {contactError &&
                            contactError.name.message !== " " && (
                              <div
                                className="error-message"
                                style={{ color: "red" }}
                              >
                                {contactError.name.message}
                              </div>
                            )}
                        </div>
                        <div className="form-group">
                          <div className="input-box">
                            <span>
                              <img src={gmailicon} alt="" />
                            </span>
                            <input
                              type="text"
                              id="email"
                              name="email"
                              placeholder={!isEmailFocused ? "Email" : ""}
                              onFocus={() => setIsEmailFocused(true)}
                              onBlur={() => setIsEmailFocused(false)}
                              class="form-control"
                              autoComplete="off"
                              value={credentialsForContact.email}
                              onChange={(e) => {
                                setCredentialsForContact({
                                  ...credentialsForContact,
                                  email: e.target.value,
                                });
                              }}
                            />
                          </div>
                          {contactError &&
                            contactError.email.message !== " " && (
                              <div
                                className="error-message"
                                style={{ color: "red" }}
                              >
                                {contactError.email.message}
                              </div>
                            )}
                        </div>
                        <div className="form-group">
                          <div className="input-box">
                            <span>
                              <img src={callicon} alt="" />
                            </span>
                            <input
                              type="tel"
                              id="phone"
                              name="phone"
                              placeholder={!isPhoneFocused ? "Phone" : ""}
                              onFocus={() => setIsPhoneFocused(true)}
                              onBlur={() => setIsPhoneFocused(false)}
                              class="form-control"
                              autoComplete="off"
                              value={credentialsForContact.phone}
                              onChange={(e) => {
                                setCredentialsForContact({
                                  ...credentialsForContact,
                                  phone: e.target.value,
                                });
                              }}
                            />
                          </div>
                          {contactError &&
                            contactError.phone.message !== " " && (
                              <div
                                className="error-message"
                                style={{ color: "red" }}
                              >
                                {contactError.phone.message}
                              </div>
                            )}
                        </div>
                        <button
                          className="cta-button"
                          onClick={(e) => handleContactsubmission(e)}
                        >
                          Done
                          <div className="arrow-icon"></div>
                        </button>
                      </div>
                    </>
                  )}
                </div>
                <div className="sell-your-car-right">
                  <img
                    src={`${configs.localApiUrl}${config?.Car_Image}`}
                    alt="sell-your-car-right-img"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="sell-your-car-elementor-widget">
            <div className="container">
              <div className="sell-your-car-elementor-widget-inner">
                <div className="sell-your-car-elementor-widget-left text-center">
                  <h1>5 REASONS TO SELL YOUR CAR WITH US</h1>
                  <p>
                    Just 5 simple steps to sell your car through WeBuyAny French
                    LHD Cars
                  </p>
                </div>
                <div className="box-wrapper">
                  <div className="box">
                    <img src={entercaricon} alt="" />
                    <div className="box-content-inner">
                      <h2>ENTER YOUR CAR REGISTRATION</h2>
                      <p>
                        To get started, simply input your vehicle’s reg on our
                        site and you’ll get a valuation range the car could be
                        worth.
                      </p>
                    </div>
                  </div>
                  <div className="box">
                    <img src={cameraicon} alt="" />
                    <div className="box-content-inner">
                      <h2>SEND US IMAGES</h2>
                      <p>
                        Lorem ipsum odor amet, consectetuer adipiscing elit.
                        Convallis dictum egestas pellentesque parturient
                        habitant.
                      </p>
                    </div>
                  </div>
                  <div className="box">
                    <img src={clearedicon} alt="" />
                    <div className="box-content-inner">
                      <h2>FINANCE CLEARED</h2>
                      <p>
                        Lorem ipsum odor amet, consectetuer adipiscing elit.
                        Convallis dictum egestas pellentesque parturient
                        habitant.
                      </p>
                    </div>
                  </div>
                  <div className="box">
                    <img src={carsicon} alt="" />
                    <div className="box-content-inner">
                      <h2>ARRANGE FREE COLLECTION</h2>
                      <p>
                        Lorem ipsum odor amet, consectetuer adipiscing elit.
                        Convallis dictum egestas pellentesque parturient
                        habitant.
                      </p>
                    </div>
                  </div>
                  <div className="box">
                    <img src={timeicon} alt="" />
                    <div className="box-content-inner">
                      <h2>SAVE TIME AND MONEY</h2>
                      <p>
                        Lorem ipsum odor amet, consectetuer adipiscing elit.
                        Convallis dictum egestas pellentesque parturient
                        habitant.
                      </p>
                    </div>
                  </div>

                </div>
                <div className="chat-btns" style={{ cursor: "pointer" }}>
                  <p>
                    <Link
                      to={`https://wa.me/${config?.Contact_Number?.replace(/\D/g, '')}`}
                      style={{ color: "white", textDecoration: "none" }}
                      target="_blank"
                    >
                      <div className="chat-icon"></div>
                      <a>CHAT TO US</a>
                    </Link>
                    {/* <a href="https://sellyourlhdcar.co.uk/">
                      <div className="chat-icon"></div> CHAT TO US
                    </a> */}
                  </p>
                  <p>
                    <a onClick={scrollToForm}>
                      SELL YOUR CAR <div className="arrow-icon"></div>
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="google-review-section">
            <div className="container">
              <div className="heading-title">
                <h1>GOOGLE REVIEWS</h1>
              </div>
              <div className="google-review-wrapper-inner first-box">
                <div className="google-content-inner">
                  <img
                    src={googlepay}
                    alt="google-img"
                    className="google-img"
                  />
                  <p>5 stars</p>
                  <img src={staricon} alt="arrow-icon" className="star-icon" />
                  <p>234 reviews</p>
                </div>
              </div>
              <div className="google-review-wrapper-boxs">
                <div className="swiper-container">
                  <Swiper
                    modules={[Autoplay, FreeMode]}
                    spaceBetween={10}
                    speed={5000}
                    direction="horizontal"
                    autoplay={{
                      delay: 0,
                      disableOnInteraction: false,
                    }}
                    navigation={{
                      nextEl: ".swiper-button-next",
                      prevEl: ".swiper-button-prev",
                    }}
                    loop={true}
                    freeMode={true}
                    slidesPerView={3}
                    breakpoints={{
                      320: { slidesPerView: 1.1 },
                      640: { slidesPerView: 1.1 },
                      1040: { slidesPerView: 3 },
                    }}
                  >
                    <SwiperSlide>
                      <div className="google-review-box">
                        <div className="google-review-img">
                          <img
                            src={staricon}
                            alt="arrow-icon"
                            className="google-img"
                          />
                          <img
                            src={googlepay}
                            alt="google-img"
                            className="star-icon"
                          />
                        </div>
                        <div className="google-review-content">
                          <h2>1 month ago</h2>
                          <p>
                            Lorem ipsum odor amet, consectetuer adipiscing elit.
                            Justo blandit sit nunc; curae enim lectus! Elit mi
                            auctor duis ligula magnis. Congue lectus rhoncus
                            odio venenatis sem. Quam sollicitudin potenti turpis
                            torquent semper.
                          </p>
                          <h2>John Smith</h2>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="google-review-box">
                        <div className="google-review-img">
                          <img
                            src={staricon}
                            alt="arrow-icon"
                            className="google-img"
                          />
                          <img
                            src={googlepay}
                            alt="google-img"
                            className="star-icon"
                          />
                        </div>
                        <div className="google-review-content">
                          <h2>1 month ago</h2>
                          <p>
                            Lorem ipsum odor amet, consectetuer adipiscing elit.
                            Justo blandit sit nunc; curae enim lectus! Elit mi
                            auctor duis ligula magnis. Congue lectus rhoncus
                            odio venenatis sem. Quam sollicitudin potenti turpis
                            torquent semper.
                          </p>
                          <h2>John Smith</h2>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="google-review-box">
                        <div className="google-review-img">
                          <img
                            src={staricon}
                            alt="arrow-icon"
                            className="google-img"
                          />
                          <img
                            src={googlepay}
                            alt="google-img"
                            className="star-icon"
                          />
                        </div>
                        <div className="google-review-content">
                          <h2>1 month ago</h2>
                          <p>
                            Lorem ipsum odor amet, consectetuer adipiscing elit.
                            Justo blandit sit nunc; curae enim lectus! Elit mi
                            auctor duis ligula magnis. Congue lectus rhoncus
                            odio venenatis sem. Quam sollicitudin potenti turpis
                            torquent semper.
                          </p>
                          <h2>John Smith</h2>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="google-review-box">
                        <div className="google-review-img">
                          <img
                            src={staricon}
                            alt="arrow-icon"
                            className="google-img"
                          />
                          <img
                            src={googlepay}
                            alt="google-img"
                            className="star-icon"
                          />
                        </div>
                        <div className="google-review-content">
                          <h2>1 month ago</h2>
                          <p>
                            Lorem ipsum odor amet, consectetuer adipiscing elit.
                            Justo blandit sit nunc; curae enim lectus! Elit mi
                            auctor duis ligula magnis. Congue lectus rhoncus
                            odio venenatis sem. Quam sollicitudin potenti turpis
                            torquent semper.
                          </p>
                          <h2>John Smith</h2>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="google-review-box">
                        <div className="google-review-img">
                          <img
                            src={staricon}
                            alt="arrow-icon"
                            className="google-img"
                          />
                          <img
                            src={googlepay}
                            alt="google-img"
                            className="star-icon"
                          />
                        </div>
                        <div className="google-review-content">
                          <h2>1 month ago</h2>
                          <p>
                            Lorem ipsum odor amet, consectetuer adipiscing elit.
                            Justo blandit sit nunc; curae enim lectus! Elit mi
                            auctor duis ligula magnis. Congue lectus rhoncus
                            odio venenatis sem. Quam sollicitudin potenti turpis
                            torquent semper.
                          </p>
                          <h2>John Smith</h2>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="google-review-box">
                        <div className="google-review-img">
                          <img
                            src={staricon}
                            alt="arrow-icon"
                            className="google-img"
                          />
                          <img
                            src={googlepay}
                            alt="google-img"
                            className="star-icon"
                          />
                        </div>
                        <div className="google-review-content">
                          <h2>1 month ago</h2>
                          <p>
                            Lorem ipsum odor amet, consectetuer adipiscing elit.
                            Justo blandit sit nunc; curae enim lectus! Elit mi
                            auctor duis ligula magnis. Congue lectus rhoncus
                            odio venenatis sem. Quam sollicitudin potenti turpis
                            torquent semper.
                          </p>
                          <h2>John Smith</h2>
                        </div>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                  <button class="cta-button d-block d-md-none">
                    MORE GOOGLE REVIEWS
                  </button>
                </div>
              </div>
            </div>
          </div> */}

          <div className="google-review-section">
            <div className="container">
              <div className="heading-title">
                <h1>GOOGLE REVIEWS</h1>
              </div>
              <div className="google-review-wrapper-boxs">
                <div className="swiper-container">
                  <Swiper
                    modules={[Autoplay, FreeMode]}
                    spaceBetween={10}
                    speed={5000}
                    direction="horizontal"
                    autoplay={{ delay: 0, disableOnInteraction: false }}
                    loop={true}
                    freeMode={true}
                    slidesPerView={3}
                    breakpoints={{
                      320: { slidesPerView: 1.1 },
                      640: { slidesPerView: 1.1 },
                      1040: { slidesPerView: 3 },
                    }}
                  >
                    {reviews?.map((review, index) => (
                      <SwiperSlide key={index}>
                        <div className="google-review-box">
                          <div className="google-review-img">
                            <img
                              src={staricon}
                              alt="star-icon"
                              className="google-img"
                            />
                            <img
                              src={googlepay}
                              alt="google-logo"
                              className="star-icon"
                            />
                          </div>
                          <div className="google-review-content">
                            <h2>{review.relative_time_description}</h2>
                            <p>{review.text}</p>
                            <h2>{review.author_name}</h2>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>

          <div className="sell-your-takeaway" ref={formSectionRef}>
            <div className="container">
              <div className="home-top-pro-section">
                <div className="home-top-pro">
                  <div className="home-top-pro-image">
                    <img
                      src={`${configs.localApiUrl}${config?.Car_Image_2}`}
                      alt=""
                    />
                  </div>
                  {!showSecondForm ? (
                    <>
                      <div className="form-container">
                        <h2>SELL YOUR CAR IN 5 EASY & SIMPLE STEPS</h2>
                        <div className="form-group">
                          <div className="input-box">
                            <span>
                              <img src={makeicon} alt="" />
                            </span>
                            <input
                              type="text"
                              id="make"
                              name="make"
                              placeholder={!isMakeFocused ? "MAKE" : ""}
                              onFocus={() => setIsMakeFocused(true)}
                              onBlur={() => setIsMakeFocused(false)}
                              class="form-control"
                              autoComplete="off"
                              value={credentials.make}
                              onChange={(e) =>
                                setCredentials({
                                  ...credentials,
                                  make: e.target.value,
                                })
                              }
                            />
                          </div>
                          {registrationError &&
                            registrationError.make.message !== "" && (
                              <div
                                className="error-message"
                                style={{ color: "black" }}
                              >
                                {registrationError.make.message}
                              </div>
                            )}
                        </div>
                        <div className="form-group">
                          <div className="input-box">
                            <span>
                              <img src={makeicon} alt="" />
                            </span>
                            <input
                              type="text"
                              id="model
                            "
                              name="model"
                              placeholder={!isModelocused ? "MODAL" : ""}
                              onFocus={() => setIsModelFocused(true)}
                              onBlur={() => setIsModelFocused(false)}
                              class="form-control"
                              autoComplete="off"
                              value={credentials.model}
                              onChange={(e) =>
                                setCredentials({
                                  ...credentials,
                                  model: e.target.value,
                                })
                              }
                            />
                          </div>
                          {registrationError &&
                            registrationError.model.message !== "" && (
                              <div
                                className="error-message"
                                style={{ color: "black" }}
                              >
                                {registrationError.model.message}
                              </div>
                            )}
                        </div>
                        <div className="form-group">
                          <div className="input-box">
                            <span>
                              <img src={makeicon} alt="" />
                            </span>
                            <input
                              type="text"
                              id="carRegistration"
                              name="carRegistration"
                              placeholder={
                                !isCaroFcused ? "YOUR CAR REGISTRATION" : ""
                              }
                              onFocus={() => setIsCarFocused(true)}
                              onBlur={() => setIsCarFocused(false)}
                              class="form-control"
                              autoComplete="off"
                              value={credentials.carRegistration}
                              onChange={(e) =>
                                setCredentials({
                                  ...credentials,
                                  carRegistration: e.target.value,
                                })
                              }
                            />
                          </div>
                          {registrationError &&
                            registrationError.carRegistration.message !==
                            "" && (
                              <div
                                className="error-message"
                                style={{ color: "black" }}
                              >
                                {registrationError.carRegistration.message}
                              </div>
                            )}
                        </div>
                        <div className="form-group">
                          <div className="input-box">
                            <span>
                              <img src={milgeicon} alt="" />
                            </span>
                            <input
                              type="text"
                              id="mileage"
                              name="mileage"
                              placeholder={!isMileageoFcused ? "MILEAGE" : ""}
                              onFocus={() => setIsMileageFocused(true)}
                              onBlur={() => setIsMileageFocused(false)}
                              class="form-control"
                              autoComplete="off"
                              value={credentials.mileage}
                              onChange={(e) =>
                                setCredentials({
                                  ...credentials,
                                  mileage: e.target.value,
                                })
                              }
                            />
                          </div>
                          {registrationError &&
                            registrationError.mileage.message !== "" && (
                              <div
                                className="error-message"
                                style={{ color: "black" }}
                              >
                                {registrationError.mileage.message}
                              </div>
                            )}
                        </div>
                        <button
                          className="cta-button"
                          onClick={(e) => handleCarRegistration(e)}
                        >
                          START MY VALUATION
                          <div className="arrow-icon"></div>
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="form-container second-form">
                        <h2>SELL YOUR CAR THE BIG WAY</h2>
                        <p>
                          Get guaranteed valuation with free collection & no
                          fees!
                        </p>
                        <div className="form-group">
                          <div className="input-box">
                            <span>
                              <img src={usericon} alt="" />
                            </span>
                            <input
                              type="text"
                              id="name"
                              name="name"
                              placeholder={!isNameFocused ? "Name" : ""}
                              onFocus={() => setIsNameFocused(true)}
                              onBlur={() => setIsNameFocused(false)}
                              class="form-control"
                              autoComplete="off"
                              value={credentialsForContact.name}
                              onChange={(e) => {
                                setCredentialsForContact({
                                  ...credentialsForContact,
                                  name: e.target.value,
                                });
                              }}
                            />
                          </div>
                          {contactError &&
                            contactError.name.message !== " " && (
                              <div
                                className="error-message"
                                style={{ color: "black" }}
                              >
                                {contactError.name.message}
                              </div>
                            )}
                        </div>
                        <div className="form-group">
                          <div className="input-box">
                            <span>
                              <img src={gmailicon} alt="" />
                            </span>
                            <input
                              type="text"
                              id="email"
                              name="email"
                              placeholder={!isEmailFocused ? "Email" : ""}
                              onFocus={() => setIsEmailFocused(true)}
                              onBlur={() => setIsEmailFocused(false)}
                              class="form-control"
                              autoComplete="off"
                              value={credentialsForContact.email}
                              onChange={(e) => {
                                setCredentialsForContact({
                                  ...credentialsForContact,
                                  email: e.target.value,
                                });
                              }}
                            />
                          </div>
                          {contactError &&
                            contactError.email.message !== " " && (
                              <div
                                className="error-message"
                                style={{ color: "black" }}
                              >
                                {contactError.email.message}
                              </div>
                            )}
                        </div>
                        <div className="form-group">
                          <div className="input-box">
                            <span>
                              <img src={callicon} alt="" />
                            </span>
                            <input
                              type="tel"
                              id="phone"
                              name="phone"
                              placeholder={!isPhoneFocused ? "Phone" : ""}
                              onFocus={() => setIsPhoneFocused(true)}
                              onBlur={() => setIsPhoneFocused(false)}
                              class="form-control"
                              autoComplete="off"
                              value={credentialsForContact.phone}
                              onChange={(e) => {
                                setCredentialsForContact({
                                  ...credentialsForContact,
                                  phone: e.target.value,
                                });
                              }}
                            />
                          </div>
                          {contactError &&
                            contactError.phone.message !== " " && (
                              <div
                                className="error-message"
                                style={{ color: "black" }}
                              >
                                {contactError.phone.message}
                              </div>
                            )}
                        </div>
                        <button
                          className="cta-button"
                          onClick={(e) => handleContactsubmission(e)}
                        >
                          Done
                          <div className="arrow-icon"></div>
                        </button>
                      </div>
                    </>
                  )}
                </div>
                {/* <div className="home-top-pro">
                  <img src={whatsApp} alt="" />
                  <h2>Talk with one of our team members right now</h2>
                  <button className="cta-button">
                    <div className="massage-icon"></div>
                    <Link
                      to={`https://wa.me/${config && config?.Contact_Number}`}
                      target="_blank"
                    >
                      {" "}
                      Chat to us
                    </Link>
                  </button>
                </div> */}
              </div>
            </div>
          </div>
          <div className="brands-stock text-center">
            <div className="head-title">
              <h2>BRANDS WE WORK WITH</h2>
              <div className="u-wrapper d-none d-md-block">
                <div className="c-carousel">
                  <Swiper
                    modules={[Autoplay]}
                    spaceBetween={10}
                    speed={2000}
                    direction="horizontal"
                    autoplay={{
                      delay: 0,
                      disableOnInteraction: false,
                    }}
                    loop={true}
                    slidesPerView={7.5}
                    freeMode={true}
                    breakpoints={{
                      320: {
                        slidesPerView: 1,
                        speed: 5000,
                      },
                      768: {
                        slidesPerView: 1,
                      },
                      1024: {
                        slidesPerView: 7.5,
                      },
                    }}
                  >
                    {brands.map((brands) => (
                      <SwiperSlide>
                        <img
                          src={`${configs.localApiUrl}${brands.brandImage}`}
                          alt="Slide 1"
                          key={brands.id}
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
              <div className="u-wrapper d-none d-md-block">
                <div className="c-carousel">
                  <Swiper
                    modules={[Autoplay]}
                    spaceBetween={10}
                    speed={2000}
                    direction="horizontal"
                    autoplay={{
                      delay: 0,
                      disableOnInteraction: false,
                      reverseDirection: true,
                    }}
                    loop={true}
                    slidesPerView={7.5}
                    freeMode={true}
                    breakpoints={{
                      320: {
                        slidesPerView: 1,
                        speed: 5000,
                      },
                      768: {
                        slidesPerView: 1,
                      },
                      1024: {
                        slidesPerView: 7.5,
                      },
                    }}
                  >
                    {brands.map((brands) => (
                      <SwiperSlide>
                        <img
                          src={`${configs.localApiUrl}${brands.brandImage}`}
                          alt="Slide 1"
                          key={brands.id}
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
              <div className="u-wrapper d-block d-md-none">
                <div className="c-carousel">
                  <Swiper
                    modules={[Autoplay]}
                    direction="horizontal"
                    loop={true}
                    freeMode={true}
                    freeModeMomentum={false}
                    slidesPerView="auto"
                    spaceBetween={gap}
                    speed={4000}
                    watchSlidesProgress={true}
                    watchSlidesVisibility={true}
                    autoplay={{
                      delay: 1,
                      disableOnInteraction: false,
                    }}
                    cssMode={false}
                  >
                    {brands.map((brands) => (
                      <SwiperSlide>
                        <img
                          src={`${configs.localApiUrl}${brands.brandImage}`}
                          alt="Slide 1"
                          key={brands.id}
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
              <div className="u-wrapper d-block d-md-none">
                <div className="c-carousel">
                  <Swiper
                    modules={[Autoplay]}
                    direction="horizontal"
                    loop={true}
                    freeMode={true}
                    freeModeMomentum={false}
                    slidesPerView="auto"
                    spaceBetween={gap}
                    speed={4000}
                    watchSlidesProgress={true}
                    watchSlidesVisibility={true}
                    autoplay={{
                      delay: 1,
                      reverseDirection: true,
                    }}
                    cssMode={false}
                  >
                    {brands.map((brands) => (
                      <SwiperSlide>
                        <img
                          src={`${configs.localApiUrl}${brands.brandImage}`}
                          alt="Slide 1"
                          key={brands.id}
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
          <div className="stm-accordion-single-unit right-hand-drive">
            <div className="container">
              <div className="stm-accordion-title">
                <h3>FREQUENTLY ASKED QUESTIONS</h3>
              </div>
              <Accordion >
                {faqList &&
                  faqList.length > 0 &&
                  faqList.map((item, index) => (
                    <Accordion.Item eventKey={index.toString()} key={index}>
                      <Accordion.Header>{item.que}</Accordion.Header>
                      <Accordion.Body>{item.ans}</Accordion.Body>
                    </Accordion.Item>
                  ))}
              </Accordion>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Home;
